// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Internal Dependencies
import AlbumPhotosAddCom from './AlbumsComs/AlbumPhotosAdd';
import { Url } from '../../../common/constants';

const AlbumPhotosAdd = (props) => {
  const { albumId } = props.match.params;

  const navigateToAlbumDetails = () => {
    props.history.push(
      Url.AlbumDetails
        .replace(':pageId', props.page.id)
        .replace(':albumId', albumId),
    );
  };

  return (
    <div className="container-fluid" style={{ height: '100dvh', overflowY: 'auto' }}>
      <div className="row">
        <div className="col-12 px-2 px-lg-3">
          <AlbumPhotosAddCom
            albumId={albumId}
            onClose={navigateToAlbumDetails}
            onComplete={navigateToAlbumDetails}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  page: state.page.selected,
});

AlbumPhotosAdd.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  page: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, null)(AlbumPhotosAdd);
